export default [
  {
    key: 'settings:0',
    path: '/settings',
    name: 'settings',
    route: 'settings',
    header: 'settings',
    meta: {
      authRequired: true,
      isAppMenu: true,
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        key: 'viewAssistants:8',
        path: '/assistants',
        name: 'assistants',
        route: 'assistants',
        icon: 'UsersIcon',
        component: () => import('@/views/assistants/AssistantList.vue'),
        meta: {
          authRequired: true,
          isAppMenu: true,
          breadcrumb: [],
          icon: 'UsersIcon',
        },
      },
      {
        key: 'viewAccount:0',
        path: '/account',
        name: 'account',
        route: 'account',
        icon: 'UserIcon',
        component: () => import('@/views/dashboard/analytics/Analytics.vue'),
        meta: {
          authRequired: true,
          isAppMenu: true,
          breadcrumb: [],
          icon: 'UserIcon',
        },
      },
      {
        key: 'viewActivity:0',
        path: '/activity',
        name: 'activity',
        route: 'activity',
        icon: 'ClipboardIcon',
        component: () => import('@/views/dashboard/analytics/Analytics.vue'),
        meta: {
          authRequired: true,
          isAppMenu: true,
          breadcrumb: [],
          icon: 'ClipboardIcon',
        },
      },
      {
        key: 'BotPermission:7',
        path: '/bot-reward',
        name: 'bot_reward',
        route: 'bot_reward',
        icon: 'CpuIcon',
        component: () => import('@/views/dashboard/analytics/Analytics.vue'),
        meta: {
          authRequired: true,
          isAppMenu: true,
          breadcrumb: [],
          icon: 'CpuIcon',
        },
      },
    ],
  },
]
